import React, { Component } from "react";
import config from "../config";
import TokenService from "../services/token-service";
import Palette from "../Palette/Palette";
import "./saved-palettes.css";
import loader from "../img/ajax-loader.gif";

class SavedPalettes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      palettes: null,
      error: null,
      loading: false,
    };
  }

  componentDidMount() {
    this.fetchSavedPalettes().then((palettes) =>
      this.setState({ palettes: palettes })
    );
  }

  deletePalette = (paletteId) => {
    const token = TokenService.getAuthToken();
    const response = fetch(
      `${config.API_ENDPOINT}/saved-palettes/${paletteId}`,
      {
        method: "DELETE",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => {
        if (res.ok) {
          return;
        }
      })
      .then(() => {
        let updatedPalettes = this.state.palettes.filter((p) => {
          return p.id !== paletteId;
        });
        this.setState({ palettes: updatedPalettes });
      })
      .catch((res) => {
        this.setState({
          error: "Something went wrong, please try again later.",
        });
      });
    return response;
  };

  async fetchSavedPalettes() {
    const token = TokenService.getAuthToken();
    this.setState({ loading: true });
    const response = await fetch(`${config.API_ENDPOINT}/saved-palettes`, {
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((colors) => {
        if (colors.ok) {
          this.setState({ loading: false });
          return colors.json();
        } else {
          this.setState({ loading: false });
          this.setState({ error: "Something went wrong, please try again." });
        }
      })
      .catch((res) => {
        this.setState({
          error: "Something went wrong, please try again later.",
        });
      });
    return response;
  }
  render() {
    return (
      <div className="color-palette search-bar">
        {this.state.palettes ? (
          <Palette
            results={this.state.palettes}
            deletePalette={this.deletePalette}
          />
        ) : (
          ""
        )}
        <span>
          {this.state.palettes &&
          this.state.palettes.length <= 0 &&
          !this.state.loading &&
          !this.state.error
            ? "No palettes saved yet"
            : ""}
          {this.state.error ? <span>{this.state.error}</span> : ""}
        </span>
        <span>
          {this.state.loading && (
            <img src={loader} alt="loading icon" className="loader" />
          )}
        </span>
      </div>
    );
  }
}

export default SavedPalettes;
